import { USER_AUTH } from 'app/modules/user/constants';

import { AUTHENTICATION_SUCCESS } from 'app/modules/app/constants';
import { authenticationSuccess, authUser } from 'infrastructure/sideEffects/authentication';

import { MESSAGE_CREATE_UPDATE_START } from 'app/modules/messages/constants';
import {
  createMessage,
  updateWelcomeMessage,
  updateCustomerUrl,
  updateCustomerTypingState,
} from 'infrastructure/sideEffects/messages';

import { WIDGET_INITIATE } from 'app/modules/ui/constants';
import { initWidget } from 'infrastructure/sideEffects/app';

import { CONFIG_FETCH } from 'app/modules/configuration/constants';
import { fetchConfig } from 'infrastructure/sideEffects/configuration';
import {
  SESSION_SET_WELCOME_MESSAGE,
  SESSION_UPDATE_URL,
  CUSTOMER_TYPING_STATE_UPDATED,
} from 'app/modules/session/constants';

import { ANSWER_UPDATE_SELECTED_ANSWER } from 'app/modules/self_service/constants';
import { updateSelectedAnswer } from 'infrastructure/sideEffects/selfService';

const ActionSideEffects = {
  //USER
  [USER_AUTH]: authUser,
  //SESSION
  [AUTHENTICATION_SUCCESS]: authenticationSuccess,
  [SESSION_SET_WELCOME_MESSAGE]: updateWelcomeMessage,
  [SESSION_UPDATE_URL]: updateCustomerUrl,
  //MESSAGE
  [MESSAGE_CREATE_UPDATE_START]: createMessage,
  //APP
  [WIDGET_INITIATE]: initWidget,
  //CONFIGURATION
  [CONFIG_FETCH]: fetchConfig,
  //TYPING
  [CUSTOMER_TYPING_STATE_UPDATED]: updateCustomerTypingState,
  // SELF SERVICE
  [ANSWER_UPDATE_SELECTED_ANSWER]: updateSelectedAnswer,
};

const gatewayMiddleware = (context, actionSideEffects = ActionSideEffects) => store => {
  return next => action => {
    const { type, record } = action;
    const sideEffect = actionSideEffects[type];
    if (sideEffect) {
      sideEffect(context, record);
    }

    return next(action);
  };
};

export default gatewayMiddleware;
